import { useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { SidebarContent } from "./Sidebar";

/** Mobile-only top bar with hamburger drawer. Hidden on md+. */
export default function MobileTopBar() {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="md:hidden sticky top-0 z-50 flex items-center justify-between px-3 border-b border-border/60 bg-background/95 backdrop-blur-xl"
      style={{
        paddingTop: "max(env(safe-area-inset-top), 0px)",
        paddingLeft: "max(env(safe-area-inset-left), 12px)",
        paddingRight: "max(env(safe-area-inset-right), 12px)",
        minHeight: "56px",
      }}
      data-testid="mobile-topbar"
    >
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" data-testid="mobile-menu-btn" aria-label="menü">
            <Menu className="w-5 h-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="p-5 w-72" data-testid="mobile-sidebar">
          <SheetTitle className="sr-only">Menü</SheetTitle>
          <SheetDescription className="sr-only">Sayfa gezinme menüsü</SheetDescription>
          <SidebarContent onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex items-center gap-2">
        <img src="/logo/qrpts-logo.png" alt="QRPTS" className="w-8 h-8 object-contain" />
        <div className="font-display font-bold tracking-tight">QRPTS</div>
      </div>

      <div className="w-9" />
    </div>
  );
}
